import { AnimatePresence } from "motion/react";
import React from "react";
import { useReducedMotion } from "../../../hooks/useReducedMotion.hook";
import { isUiMotionEnabled } from "../../shared/motion/uiMotion.tools";

interface SavedItineraryListPresenceProps {

    /** Keyed {@link SavedItineraryListItemMotion} rows. */
    "children": React.ReactNode;

    /** Fired when the last exit animation completes. */
    "onExitComplete"?: () => void;
}

/**
 * Enables exit animations for saved-itinerary list rows.
 *
 * @remarks Layout projection for section titles and siblings is owned by the parent
 * {@link LayoutGroup} in the saved list so open/close reflow stays coordinated.
 *
 * @param props Presence wrapper props.
 * @returns AnimatePresence shell or passthrough fragment when motion is off.
 */
const SavedItineraryListPresence: React.FC<SavedItineraryListPresenceProps> = ( {
    children,
    onExitComplete,
} ) => {
    const reducedMotion = useReducedMotion();
    const animationsEnabled = isUiMotionEnabled( reducedMotion );

    if ( !animationsEnabled ) {
        return children;
    }

    return (
        <AnimatePresence
            initial={false}
            onExitComplete={onExitComplete}
        >
            {children}
        </AnimatePresence>
    );
};

export default SavedItineraryListPresence;
